module.exports = __webpack_public_path__ + "static/img/logo_38.4a16965.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_38.png
// module id = Zq2H
// module chunks = 1